<template>
  <div class="current-step" :style="containerStyle">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="sizeClasses[size]"
      :height="sizeClasses[size]"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z"
        fill="#7F56D9"
      />
      <path
        d="M16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1Z"
        stroke="#7F56D9"
        stroke-width="2"
      />
      <circle cx="16" cy="16" r="5" fill="white" />
    </svg>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  size: {
    type: String,
    default: "large",
    validator: (value) => ["small", "medium", "large"].includes(value),
  },
});

const sizeClasses = computed(() => {
  return {
    small: "24",
    medium: "32",
    large: "40",
  };
});

const containerStyle = computed(() => {
  return {
    width: `${sizeClasses.value[props.size]}px`,
    height: `${sizeClasses.value[props.size]}px`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
});
</script>

<style scoped>
.current-step {
  border-radius: 9999px;
  background: #f9f5ff;
  box-shadow: 0 0 0 4px rgba(158, 119, 237, 0.24);
}
</style>
